import {combineReducers} from '@modifi/redux'
import {KeyWindowState} from '@modifi/redux/lib/esm/factories/collection/reducer'
import {ExistingFinancialDataSetView} from '@modifi/onboarding-api-clients'

import collectionReducer from './collection'

export type FinancialDataSetState = {
  collection: KeyWindowState<ExistingFinancialDataSetView>
}

export default combineReducers({
  collection: collectionReducer,
})
